import { apiCloudEnvUrl, apiEnvUrl, switchENV } from '../components/shared/Links';



const newConsentAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/clients/me/summary`;

const viewIpAPI = () => `${switchENV(
    apiCloudEnvUrl
)}/adv-disc-svc/service/investment-proposal/v1/proposal/latest`;


const viewPlanAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v2/document/latest?allEngagements=false&docType=FINANCIAL_PLAN`;

export default {
    newConsentAPI,
    viewPlanAPI,
    viewIpAPI
};
